import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {User} from '../../entities/user/user.entity';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService
{
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public getUser(): Observable<User> {
    return this.http.get<User>(`${environment.apiUrl}/user`);
  }

  public updateUser(
    firstname: string | null = null,
    lastname: string | null = null,
    online: boolean | null = null,
    city: string | null = null,
    tags: string[] | null = null,
    biography: string | null = null,
    iban: string | null = null,
    bic: string | null = null,
  ): Observable<User> {
    const payload: any = {
      ...(firstname !== null && { firstname }),
      ...(lastname !== null && { lastname }),
      ...(online !== null && { online }),
      ...(city !== null && { city }),
      ...(tags !== null && { tags }),
      ...(biography !== null && { biography }),
      ...(iban !== null && { iban }),
      ...(bic !== null && { bic }),
    };

    return this.http.post<User>(`${environment.apiUrl}/user`, payload);
  }

  public updateUserImage(file: File): Observable<User> {
    const formData = new FormData();
    formData.append('image', file);
    return this.http.post<User>(`${environment.apiUrl}/user/image`, formData);
  }

}
